import { useState, useEffect } from 'react';
import ReportsView from './ReportsView';
import useUniversalStore from 'store/universalStore';
import useOffcanvasStore from 'store/offcanvasStore';
import { sendWAReminder } from 'utils';
import { formatMoney } from 'utils';
import { reminderAPI } from 'services';
import dayjs from 'dayjs';

const Footer = ({ account }) => {
    const { profile, accountId } = useUniversalStore((state) => state);
    const [reportLoading, setReportLoading] = useState({ pdf: false, excel: false });
    const { openOffcanvas } = useOffcanvasStore((state) => state);
    const [overdue, setOverdue] = useState(false);

    useEffect(() => {
        getOverdueStatus();
    }, [accountId]);

    const getOverdueStatus = async () => {
        const reminders = await reminderAPI.fetchReminder(accountId);
        if (reminders?.length > 0) {
            const reminderDate = new Date(reminders[0].get("date"));
            dayjs(reminderDate).isBefore(dayjs(new Date())) ? setOverdue(true) : setOverdue(false);
        } else {
            setOverdue(false);
        }
    }

    const scheduleReminder = () => {
        openOffcanvas("reminder");
    }

    if (!account) return null;

    return (
        <div className="sticky-bottom bg-app py-2 px-2 px-md-3 text-white">
            <div className="row g-0 align-items-center">
                <div className="col-12 col-md-6 mb-2 mb-md-0">
                    <span className="fs-5 fs-md-3 d-flex align-items-center justify-content-center justify-content-md-start">
                        Balance :
                        <span className="ms-2 ms-md-4 fs-6 fs-md-5"><i>{formatMoney(account.get("balance"))}</i></span>
                    </span>
                </div>
                <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-center justify-content-md-end gap-1 gap-md-2">
                        <div className="btn btn-sm bg-app p-1 position-relative"
                            onClick={scheduleReminder}>
                            <i className="bi bi-alarm fs-3 fs-md-2 text-white" />
                            {overdue && <span className="position-absolute py-1 px-2 top-0 start-100 translate-middle badge bg-danger fs-6 rounded-pill">1</span>}
                        </div>

                        <div className="btn btn-sm bg-app p-1"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#rcTxnsView">
                            <i className="bi bi-arrow-repeat fs-3 fs-md-2 text-white" />
                        </div>

                        <div className="dropdown p-0">
                            <div className="btn btn-sm bg-app p-1"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                {reportLoading.pdf ?
                                    <span className="spinner-border text-white border-2" style={{ width: '1.5rem', height: '1.5rem' }} role="status" aria-hidden="true" />
                                    : <i className="bi bi-file-pdf fs-3 fs-md-2 text-white" />
                                }
                            </div>
                            <ReportsView setReportLoading={setReportLoading} type="pdf" />
                        </div>

                        <div className="dropdown p-0">
                            <div className="btn btn-sm bg-app p-1"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                {reportLoading.excel ?
                                    <span className="spinner-border text-white border-2" style={{ width: '1.5rem', height: '1.5rem' }} role="status" aria-hidden="true" />
                                    : <i className="bi bi-filetype-xls fs-3 fs-md-2 text-white" />
                                }
                            </div>
                            <ReportsView setReportLoading={setReportLoading} type="excel" />
                        </div>

                        <div className="btn btn-sm bg-app p-1"
                            title="Remind" onClick={() => sendWAReminder(account)}>
                            <i className="bi bi-whatsapp fs-3 fs-md-2 text-white" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;